import React from 'react';
import classNames from 'classnames';
import './styles.scss';
import Icon from '../Icon/Icon';
import { useAppContext } from '../../../AppContext';
import styled, { css } from 'styled-components';
import { DictionaryType } from '../../types/DictionaryType';

enum AlertVariants {
  Success = 'success',
  Error = 'error',
  Warning = 'warning',
  Info = 'info',
}

type Props = {
  variant: AlertVariants;
  text?: string;
  className?: string;
  children?: React.ReactNode;
  icon?: boolean;
};

const icons = {
  [AlertVariants.Info]: 'fas fa-info-circle',
  [AlertVariants.Warning]: 'fas fa-exclamation-triangle',
  [AlertVariants.Error]: 'fas fa-times',
  [AlertVariants.Success]: 'fas fa-check-circle',
};

const Alert = (props: Props) => {
  const context = useAppContext();
  const primaryClassName = 'c-alert';

  const cssclass = classNames(primaryClassName, props.variant, props.className && props.className);

  return (
    <AlertWrapper styles={context.styles} variant={props.variant} className={cssclass}>
      {props.icon && icons[props.variant] && (
        <div className="c-alert_icon">
          <Icon icon={icons[props.variant]} iconVariant={Icon.Variants.FontAwesome} />
        </div>
      )}
      <div className="c-alert_message">{props.children ? props.children : props.text}</div>
    </AlertWrapper>
  );
};

const AlertWrapper = styled.div<{
  styles: DictionaryType<DictionaryType<string>>;
  variant: AlertVariants;
}>`
  ${(props) => {
    const styleSettingName = props.styles[`module:alert:${props.variant}`];
    let styles = '';

    if (styleSettingName && styleSettingName.textColor) {
      styles = `
            color: ${styleSettingName.textColor}; 
            a { color: ${styleSettingName.textColor}; }
            ${styles}
        `;
    }

    if (styleSettingName && styleSettingName.backgroundColor) {
      styles = `background-color: ${styleSettingName.backgroundColor} !important; } ${styles}`;
    }

    return css`
      & {
        ${styles}
      }
    `;
  }}
`;

Alert.Variants = AlertVariants;

export default Alert;
